/* Dirt Masters — predictive search fallback for vehicle-qualified queries.
 *
 * Shopify's predictive API requires EVERY word to match and does not search
 * tags, so a query like "rzr 1000 axle" returns zero suggestions even though
 * full search has 100+ hits — the numbers live in fitment tags, not titles.
 * When a productless response comes back for a query containing numeric
 * tokens, retry once with the numbers stripped and show those products.
 * The "Search for…" button still submits the user's full original query
 * (it submits the form input, not its label), so full search is unaffected.
 *
 * Patches the custom element prototype — Dawn's predictive-search.js stays
 * untouched to keep the upgrade path.
 */
(() => {
  const PRODUCT_MARKER = 'predictive-search-option-product';

  // "rzr 1000 axle" -> "rzr axle"; null when stripping wouldn't change anything
  function strippedQuery(term) {
    const words = term.trim().split(/\s+/);
    const kept = words.filter((w) => !/^\d{2,4}$/.test(w));
    if (kept.length === words.length || kept.length === 0) return null;
    return kept.join(' ');
  }

  customElements.whenDefined('predictive-search').then(() => {
    const PS = customElements.get('predictive-search');
    const original = PS.prototype.renderSearchResults;

    PS.prototype.renderSearchResults = function (markup) {
      const term = this.searchTerm;
      const fallback = term ? strippedQuery(term) : null;
      if (!fallback || markup.includes(PRODUCT_MARKER)) {
        original.call(this, markup);
        return;
      }

      fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(fallback)}&section_id=predictive-search`)
        .then((response) => (response.ok ? response.text() : Promise.reject(new Error(response.status))))
        .then((text) => {
          const section = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search');
          if (!section || !section.innerHTML.includes(PRODUCT_MARKER)) {
            throw new Error('fallback had no products');
          }
          // Relabel "Search for "rzr axle"" back to the user's full query —
          // the button submits the form input, so behavior already matches.
          const label = section.querySelector('[data-predictive-search-search-for-text]');
          if (label) label.textContent = label.textContent.replace(fallback, term);
          // User kept typing while we fetched — a newer render owns the box.
          if (this.searchTerm !== term) return;
          original.call(this, section.innerHTML);
        })
        .catch(() => {
          if (this.searchTerm === term) original.call(this, markup);
        });
    };
  });
})();
